// "Prices" v2 (29.10.2026): one page DAM · IDM · BM, forecast lines BASE and EXPRO.
const translations: Record<string, string> = {
  "pv2_accuracy": "Forecast accuracy",
  "pv2_accurate_hint": "accurate hour — BASE error ≤ {{rel}} % of actual, but at least {{abs}} UAH",
  "pv2_accurate_hours": "accurate hours",
  "pv2_after_fact": "available once the actual price is published",
  "pv2_badge_fact": "ACTUAL",
  "pv2_band": "Likely price range 10–90 %",
  "pv2_band_title": "Show or hide the likely price range",
  "pv2_bm": "BM",
  "pv2_br_fact": "Actual",
  "pv2_br_oper": "Operational",
  "pv2_dam": "DAM",
  "pv2_day": "Day",
  "pv2_deviation": "Deviation",
  "pv2_download_cards": "Download indicators",
  "pv2_download_hourly": "Download hourly data",
  "pv2_empty": "No DAM data for {{d}}. Tomorrow's prices appear today at 12:45–13:15 Kyiv time.",
  "pv2_err_base": "BASE error",
  "pv2_expro_pending": "The EXPRO line appears after the first daily run (ExPro analysis)",
  "pv2_hour": "Hour",
  "pv2_hourly_title": "Hourly DAM prices",
  "pv2_idm": "IDM",
  "pv2_idm_empty": "No IDM data for {{d}}.",
  "pv2_idm_hourly": "Hourly IDM prices",
  "pv2_idm_title": "IDM prices",
  "pv2_k_uah": "k UAH",
  "pv2_line_fact": "Actual",
  "pv2_line_naive": "Previous-day price",
  "pv2_loading": "Loading…",
  "pv2_m_uah": "M UAH",
  "pv2_month_days": "over {{n}} days with both actual and forecast",
  "pv2_month_sub": "daily BASE index: actual and the forecast fixed before bid submission",
  "pv2_month_title": "DAM prices for the month",
  "pv2_mwh": "MWh",
  "pv2_n_days": "{{n}} d",
  "pv2_naive_date": "Price {{d}}",
  "pv2_naive": "Previous-day price",
  "pv2_naive_title": "Prices of the same hour on {{d}} — the baseline: a forecast must beat them",
  "pv2_no_run": "no forecast",
  "pv2_of_hours": "of {{n}} h",
  "pv2_of_hours_short": "{{a}} of {{n}}",
  "pv2_period_day": "Daily",
  "pv2_period_month": "Monthly",
  "pv2_q_accurate": "Accurate hours",
  "pv2_q_band": "Within 10–90 %",
  "pv2_q_band_w": "Within 10–90 % · width",
  "pv2_q_bess": "Luchky BESS cycle",
  "pv2_q_days": "Days",
  "pv2_q_line": "Line",
  "pv2_q_mae": "Mean error",
  "pv2_quality_month_note": "In brackets — previous-day price on the same days. BESS cycle: plan from the forecast, valued at actual prices; % of the ideal (plan from actual prices).",
  "pv2_quality_month_sub": "Each line against the previous-day price — in UAH and hours",
  "pv2_quality_month_title": "Forecast quality for the month",
  "pv2_quality_note": "Accurate hour — error ≤ {{rel}} % of actual, but at least {{abs}} UAH. Luchky BESS cycle: charge/discharge plan from the forecast, valued at actual prices; % of the ideal plan.",
  "pv2_quality_sub": "Each line against the previous-day price: error in UAH, accurate hours, BESS cycle money",
  "pv2_quality_title": "How the forecast performed",
  "pv2_retro": "retro",
  "pv2_level_estimate": "level estimate",
  "pv2_row_acc_base": "BASE accurate hours",
  "pv2_row_acc_naive": "Accurate hours: previous-day price",
  "pv2_row_base": "BASE, UAH/MWh",
  "pv2_row_base_band": "BASE, range 10–90 %",
  "pv2_row_base_base": "BASE (forecast), day index",
  "pv2_row_dev_base": "Deviation from BASE, %",
  "pv2_row_dev_expro": "Deviation from EXPRO, %",
  "pv2_row_expro": "EXPRO, UAH/MWh",
  "pv2_row_expro_base": "EXPRO (forecast), day index",
  "pv2_row_fact": "Price, actual",
  "pv2_row_fact_base": "Actual, daily BASE index",
  "pv2_row_naive": "Previous-day price",
  "pv2_row_naive_base": "Previous day, index",
  "pv2_row_volume": "Volume, MWh",
  "pv2_run_from": "from {{d}} (D+{{h}}, {{model}})",
  "pv2_sub_fact": "actual",
  "pv2_sub_nofact": "actual appears after the auction",
  "pv2_uah": "UAH",
  "pv2_unit": "UAH/MWh",
  "pv2_volume": "Volume",
  "pv2_weighted": "Weighted average price",
  "pv2_x_all": "Whole period",
  "pv2_x_bad_range": "The \"from\" date must not be later than \"to\"",
  "pv2_x_busy": "Building the file for {{n}} days…",
  "pv2_x_cancel": "Cancel",
  "pv2_x_clock": "Time",
  "pv2_x_close": "Close",
  "pv2_x_date": "Date",
  "pv2_x_dev_base": "Deviation from BASE, %",
  "pv2_x_download": "Download .xlsx",
  "pv2_x_fact": "actual",
  "pv2_x_failed": "Could not build the file. Please try again",
  "pv2_x_from": "from",
  "pv2_x_h_day": "selected day",
  "pv2_x_h_month": "month of the selected day",
  "pv2_x_h_year": "year of the selected day",
  "pv2_x_model_base": "BASE model",
  "pv2_x_model_expro": "EXPRO model",
  "pv2_x_nodata": "No {{m}} data for the selected period",
  "pv2_x_ok": "File is ready, download started",
  "pv2_x_p_custom": "Custom",
  "pv2_x_p_day": "Day",
  "pv2_x_p_month": "Month",
  "pv2_x_p_year": "Year",
  "pv2_x_period": "Period",
  "pv2_x_price": "Price, UAH/MWh",
  "pv2_x_sub_cards_dam": "{{m}} prices (actual and BASE / EXPRO forecasts, OREE): weighted, BASE, PEAK, OFFPEAK per day",
  "pv2_x_sub_cards_idm": "{{m}} prices (actual, OREE): weighted, BASE, PEAK, OFFPEAK per day",
  "pv2_x_sub_hourly_dam": "Hourly {{m}} prices and volumes: actual, BASE (with range), EXPRO, previous-day price",
  "pv2_x_sub_hourly_idm": "Hourly {{m}} prices and volumes (actual, OREE)",
  "pv2_x_title": "Download to Excel",
  "pv2_x_to": "to",
  "pv2_x_too_long": "Too many days (max {{n}})",
};

export default translations;
